
<template>
	<section>
		<compFormQuery
			col="1"
			class="margin-layout width-60per"
			ref="formbase"
			:formdata="getBase"
			:value="formData"
			:labelWidth="120"
		/>
		<div class="text-right padding-right-10 padding-bottom-10">
			<vButton @click="close">关闭</vButton>
		</div>
		<vLoading loading size="large" transfer v-if="loading"></vLoading>
	</section>
</template>

<script>
import mixin from './detailmixin';
export default {
	mixins: [mixin],
	props: ['id'],
	methods: {
		close() {
			this.$emit('on-close');
		}
	},
}
</script>


